import { createDefaultTyrann } from '@apis/common';
import {
  vesselScheduleItem,
  vesselScheduleItemCreate,
  vesselScheduleItemPatch,
  vesselScheduleQuery,
} from '@models/VesselSchedule';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const vesselScheduleApis = createDefaultTyrann({
  '/dashboard/vessel-schedule/': {
    get: {
      query: vesselScheduleQuery,
      response: {
        200: t.type({
          count: t.number,
          next: h.omittable(t.string),
          previous: h.omittable(t.string),
          results: t.array(vesselScheduleItem),
        }),
      },
    },
    post: {
      body: t.array(vesselScheduleItemCreate),
      response: {
        201: t.array(t.type({})),
        400: t.array(t.type({})),
      },
    },
  },
  '/dashboard/vessel-schedule/{id}/': {
    get: {
      path: t.type({ id: t.number }),
      response: {
        200: vesselScheduleItem,
      },
    },
    patch: {
      path: t.type({ id: t.number }),
      body: vesselScheduleItemPatch,
      response: {
        200: t.type({}),
        400: t.type({}),
        406: t.array(t.string),
      },
    },
  },
});
